export default __webpack_public_path__ + "static/media/SY.692b626d.ico";